/* eslint-disable no-use-before-define */
import { delay } from 'redux-saga';
import { all, call, put, take, takeLatest, race } from 'redux-saga/effects';
// import queryString from 'query-string';

import * as API from '../api/searchFieldsAPI';
import * as actions from '../actions/SearchFieldActions';
import * as StartAppActions from '../actions/StartApp.Actions';
// import * as ParameterActions from '../actions/SearchParameter.Actions';
// import * as UIActions from '../actions/UIActions';

function TimeoutException() {
  this.status = 408;
  this.message = 'Request Timeout';
}

function CancelException() {
  this.status = 400;
  this.message = 'Cancelled Request';
}

const timeoutTime = 120 * 1000;

function* doStartAppProcess({ payload: history }) {
  yield call(delay, 500);

  const { pathname /* , search */ } = history.location;

  try {
    const [
      { sources },
      { umbo_categories: categories },
      // { cameras },
      { batches },
      { models }
    ] = yield call(doFetchAvailableInputOptions);

    /*
     *  Compose the response which collects different search field
     *  available options
     */
    const response = {
      sources,
      categories,
      // cameras,
      batches
    };

    /* Update Models immediately */
    yield put(actions.updateModels({ models }));

    yield put(StartAppActions.startAppComplete({ SearchParameter: response }));

    /*
     *  If URL have any search params in it, convert paramter
     *  route to search input
     */
    // if (search !== '') {
    //   yield call(doParseSearchParameterToFieldInputs, search);
    // }

    /* Auto-Search Images when start APP complete */
    yield put(actions.searchImages());

    // if (/\/batch_evaluation/.test(pathname)) {
    //   yield put(actions.searchBatchEvaluation());
    // }

    if (/\/segmentation/.test(pathname)) {
      const imageSN = Number(
        pathname
          .match(/[0-9]+\/segmentation/)[0]
          .match(/[0-9]+/)[0]
      );
      yield put(actions.searchImage(imageSN));
    }
  } catch (error) {
    if (error.status === 408) {
      yield put(StartAppActions.startAppTimeout());
    } else if (error.status === 400) {
      /* DO NOTHING SINCE ACTION ALREADY BEING DISPATCHED BY USER */
      // Uncomment if need to have other way dispatch cancel action
      // yield put(StartAppActions.startAppCancel());
    } else {
      yield put(StartAppActions.startAppFailure());
    }
  }
}

function* doFetchAvailableInputOptions() {
  const { response, timeout, cancel } = yield race({
    response: all([
      call(API.fetchSources),
      call(API.fetchCategories),
      // call(API.fetchCameras),
      call(API.fetchBatches),
      call(API.fetchModels)
    ]),
    timeout: call(delay, timeoutTime),
    cancel: take('START_APP_CANCEL')
  });

  if (timeout) {
    throw new TimeoutException();
  } else if (cancel) {
    throw new CancelException();
  }
  return response;
}

// function* doParseSearchParameterToFieldInputs(search) {
//   const parameter = queryString.parse(search);
//   const keys = Object.keys(parameter);

//   let imgZippedIDs;
//   let imgStartID;
//   const imgSize = { mode: 'disabled', width: {}, height: {} };

//   for (let i = 0; i < keys.length; i += 1) {
//     const key = keys[i];
//     let value = parameter[key];
//     value = value instanceof Array ? value : [value];

//     switch (key) {
//       case 'source':
//         yield put(ParameterActions.updateSourceInput(value));
//         yield put(UIActions.toggleSourceInput());
//         break;
//       case 'category':
//         yield put(ParameterActions.updateCategoryInput(value));
//         yield put(UIActions.toggleCategoriesInput());
//         break;
//       case 'camera':
//         yield put(ParameterActions.updateCameraInput(value));
//         yield put(UIActions.toggleCameraInput());
//         break;
//       case 'batch':
//         yield put(ParameterActions.updateBatchInput(value));
//         yield put(UIActions.toggleBatchInput());
//         break;
//       case 'imageID':
//         yield put(ParameterActions.updateImageSnInput(value.map(v => Number(v))));
//         yield put(UIActions.toggleImageSnInput());
//         break;
//       case 'imageSizeMode':
//         [imgSize.mode] = value;
//         yield put(UIActions.switchImageSizeSearchMode(imgSize.mode));
//         yield put(UIActions.toggleImageSizeInput());
//         break;
//       case 'upperWidth':
//         imgSize.width.max = Number(value[0]);
//         break;
//       case 'lowerWidth':
//         imgSize.width.min = Number(value[0]);
//         break;
//       case 'upperHeight':
//         imgSize.height.max = Number(value[0]);
//         break;
//       case 'lowerHeight':
//         imgSize.height.min = Number(value[0]);
//         break;
//       /* TODO: Implement other kind of search */
//       case 'evaluatedImageFilter':
//         yield put(ParameterActions.updateEvaluatedImageFilter(true));
//         break;
//       case 'imageTime':
//         break;
//       case 'i':
//         imgZippedIDs = value.map(v => Number(v));
//         break;
//       case 'img_start_id':
//         imgStartID = Number(value[0]);
//         break;
//       default:
//         console.log(`Unhandled URL parameter: ${key} - ${value}`);
//         break;
//     }
//   }

//   /* ImageSize search */
//   if (imgSize.mode !== 'disabled') {
//     yield put(ParameterActions.updateImageSize(imgSize));
//   }

//   /* Dezip the selected image ID array */
//   if (typeof imgStartID === 'number' && imgZippedIDs instanceof Array) {
//     const imgIDs = imgZippedIDs.map(id => id + imgStartID);
//     yield put(actions.updateSelectedImages(imgIDs));
//   }
// }

export default function* startAppTransaction() {
  yield takeLatest('START_APP', doStartAppProcess);
}



// WEBPACK FOOTER //
// ./src/sagas/StartApp.Saga.js